export const notificationLinkRegexp: RegExp = /\[link=(?<type>[^:\]]+):(?<id>[^\]]*)\](?<title>[\s\S]*?)\[\/link\]/g;
